import { Skeleton } from "@mui/material";
import React from "react";

interface ReportSkeletonProps {
  isFormattedReport?: boolean;
}

const ReportSkeleton = (props: ReportSkeletonProps) => {
  const { isFormattedReport } = props;

  if (isFormattedReport) {
    return (
      <div className="dui-report-skeleton-wrapper">
        <Skeleton
          variant="rounded"
          height={310}
          width={640}
          className="dui-report-skeleton"
        />
      </div>
    );
  }
  return (
    <div className="dui-report-skeleton-wrapper">
      <Skeleton
        variant="rounded"
        height={390}
        width={640}
        className="dui-report-skeleton"
      />
    </div>
  );
};

export default ReportSkeleton;
